module.exports = __webpack_public_path__ + "static/media/s1.52472df4.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/s1.png
// module id = 126
// module chunks = 0